export const currencyToNumber = (str) => {
  try {
    if (!str) return null;
    if (typeof str === 'number') return str;

    const strNum = str.split(' ')?.[1]
    if (!strNum) return null

    const num = parseFloat(strNum.replace(/,/g, '').replace(/\./g, ''));
    return isNaN(num) ? null : num;
  } catch (error) {
    console.error('Error converting currency to number:', error);
    return null;
  }
};